import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import {
    EnrollmentRegisterServiceInit
} from "../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import Loader from "../../../../components/shared/loader/Loader";
import {
    APP,
    NativeAPP_GAEvents,
    countriesWithMandatoryPOTOSConsent
} from "../../../../constants/AppConstants";
import {
    getNativeAppName,
    redirectToBplusNativeApp,
    trackGANativeApp
} from "../../../../constants/AppMethod";
import SmartSavingOptInScreen from "../SmartSavingOptInScreen/SmartSavingOptInScreen";
import {
    updateUserNotificationConsentStateRequest
} from "../../../../store/brotherPlus/UserNotificationConsent/UpdateUserNotificationConsentStateSlice";
import { getCountryCode } from "../../../../utils/Internationalization/handleAppInternationalization";
import { getUserNotificationConsentDetailsRequest } from "../../../../store/brotherPlus/UserNotificationConsent/GetUserNotificationConsentDetailsSlice";
import { evaluateConsent, buildConsentPayload } from "../../../../utils/consentService";
import { useUserNotificationConsent } from "../../../../utils/CustomHooks/useUserNotificationConsent";
const DEFAULT_PLATFORM = "App";
const RegisterBplusService = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [userConsent, setUserConsent] = useState(null);
    const [showSmartSavings, setShowSmartSavings] = useState(false);
    const enrollmentDispatched = useRef(false);
    const {
        loading: enrollmentLoading,
        success: enrollmentSuccess,
        error: enrollmentError,
    } = useSelector((state) => state.BROTHERPLUS.RegisterService);

    const { inAppConsent, success: getConsentSuccess, error: getConsentError } = useUserNotificationConsent();

    const {
        loading: putConsentLoading,
        success: putConsentSuccess,
        error: putConsentError,
    } = useSelector((state) => state.BROTHERPLUS.updateUserNotificationConsentState);
   
    const appName = getNativeAppName();
    const countryCode = getCountryCode();
    const isMandatoryConsentCountry = countriesWithMandatoryPOTOSConsent.includes(countryCode);
    const getConsentResolved = getConsentSuccess || getConsentError;

    const dispatchEnrollment = () => {
        if (enrollmentDispatched.current) return;
        enrollmentDispatched.current = true;
        dispatch(EnrollmentRegisterServiceInit({
            userPlatform: appName || DEFAULT_PLATFORM,
        }));
    };
    const handlePostEnrollmentConsent = (userConsentPreference) => {
        if (getConsentError) {
            redirectToBplusNativeApp(history, true);
            return;
        }
        const consentDecision = evaluateConsent({
            consentValue: inAppConsent ,
            enrolmentSource: APP,
        });
        if (consentDecision.shouldUpdate) {
            dispatch(updateUserNotificationConsentStateRequest(consentDecision.payload));
        } else if (userConsentPreference !== null) {
            const { payload } = buildConsentPayload({
                userConsent: { appConsent: userConsentPreference},
                enrolmentSource: APP,
            });
            dispatch(updateUserNotificationConsentStateRequest(payload));
        } else {
            redirectToBplusNativeApp(history, true);
        }
    };
    const handleBannerConsent = (consent) => {
        setUserConsent(consent);
        dispatchEnrollment();
    };

    useEffect(() => {
        trackGANativeApp(NativeAPP_GAEvents.BPLUS_REGISTER_SERVICE);
        dispatch(getUserNotificationConsentDetailsRequest());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!getConsentResolved) return;

        if (getConsentError) {
            dispatchEnrollment();
            return;
        }
        // mandatory country + null: auto-enroll, no banner (new user / never set)
        if (isMandatoryConsentCountry && inAppConsent  === null) {
            dispatchEnrollment();
            return;
        }
        const consentDecision = evaluateConsent({
            consentValue: inAppConsent ,
            enrolmentSource: APP,
        });
        if (consentDecision.shouldShowBanner) {
            setShowSmartSavings(true);
        } else {
            dispatchEnrollment();
        }
        // eslint-disable-next-line
    }, [getConsentSuccess, getConsentError]);

    useEffect(() => {
        if (enrollmentError) {
            redirectToBplusNativeApp(history, false);
            return;
        }
        if (!enrollmentSuccess) return;
        if (!getConsentResolved) return;
        handlePostEnrollmentConsent(userConsent);
        // eslint-disable-next-line
    }, [
        enrollmentSuccess, 
        enrollmentError, 
        getConsentSuccess, 
        getConsentError
    ]);

    useEffect(() => {
        if (putConsentSuccess || putConsentError) {
            redirectToBplusNativeApp(history, true);
        }
        // eslint-disable-next-line
    }, [putConsentSuccess, putConsentError]);

    if (showSmartSavings) {
        return (
            <SmartSavingOptInScreen
                onConsentSelected={handleBannerConsent}
                putConsentLoading={putConsentLoading || enrollmentLoading}
            />
        );
    }
    return <Loader />;
};
export default RegisterBplusService;